import CompanyPostedJobs from "../../components/companyPostedJob/CompanyPostedJobs"

function CompanyPostedJobsPage() {
    return (
        <>
        <CompanyPostedJobs/>
        </>
    )
}
export default CompanyPostedJobsPage